import transport from "@/assets/schober/transport.webp";
import entruempelung from "@/assets/schober/entruempelung.webp";
import messie from "@/assets/schober/messie.webp";
import demontage from "@/assets/schober/demontage.webp";
import gruenschnitt from "@/assets/schober/gruenschnitt.webp";

export const services = [
  {
    image: transport,
    title: "Transporte & Umzüge",
    text: "Schober Transportservice ist Ihr verlässlicher Partner für reibungslose Transport- und Umzugsarbeiten. Von der sicheren Verpackung bis zum zuverlässigen Transport Ihrer persönlichen Gegenstände bieten wir umfassende Lösungen für Ihre Übersiedlung. Maßgeschneiderte Lösungen, professioneller Service und persönliche Betreuung stellen sicher, dass Ihr Umzug effizient, sorgfältig und stressfrei abläuft.",
  },
  {
    image: entruempelung,
    title: "Entrümpelungen & Sperrgut",
    text: "Ob Wohnung, Dachboden oder Keller, wir helfen Ihnen dabei, die Herausforderungen einer Entrümpelung oder Haushaltsauflösung zu meistern. Schnell und effizient wird von unserem Team unnötiges Gerümpel wie alte Möbel, Haushaltsgegenstände oder elektronische Geräte entfernt, damit Ihr Zuhause wieder sauber und attraktiv wirkt. Das Räumgut transportieren wir ab; die weitere Behandlung und Verwertung erfolgt ausschließlich über hierzu befugte Betriebe.",
  },
  {
    image: messie,
    title: "Räumungen von Messie-Objekten",
    text: "Als Spezialisten für Entrümpelungen scheuen wir auch vor großen Aufgaben nicht zurück. So kümmern wir uns ebenfalls um stark verwahrloste bzw. verdreckte Wohnungen, Wohnhäuser und Liegenschaften. Im Zuge meiner langjährigen Tätigkeit als Polizist sind mir solche Wohnungen nicht unbekannt und meinem Team ist bewusst, dass diese Projekte Verständnis und Diskretion erfordern. Bei Schober Transportservice ist Ihr Objekt in guten Händen!",
  },
  {
    image: demontage,
    title: "Demontagearbeiten",
    text: "Schober Transportservice bietet professionelle Lösungen für Demontagearbeiten. Unser erfahrenes Team übernimmt die Entfernung von Bodenbelägen, Wandfliesen oder Küchen und führt Teil-Entkernungen durch. Dabei legen wir Wert auf die präzise Ausführung der Arbeiten und übernehmen anschließend den Abtransport des Räumguts.",
  },
  {
    image: gruenschnitt,
    title: "Grünschnitt-Abtransport",
    text: "Schober Transportservice kümmert sich um die effiziente Beseitigung von Grünschnitt. Unser Ziel ist es, sicherzustellen, dass Ihr Garten stets gepflegt aussieht. Daher übernehmen wir neben dem Abtransport von Grünschnitt auch unterstützende Tätigkeiten wie Rasenmähen oder Laubrechen mit dem anschließenden Abtransport des anfallenden Räumguts. Gerne erstellen wir Ihnen Ihr individuelles Angebot für die regelmäßige Unterstützung bei der Gartenpflege.",
  },
];

// Quadratische Service-Icons (250x250) bringen sich besser auf hellem Grund zur Geltung,
// daher zusätzlicher Style-Hinweis im ServiceBlock.
